<template>
  <div class="main">
    <div class="tabbar">
      <div
        v-for="(item, i) of tabs"
        :key="i"
        class="item"
        :class="{ active: tabIndex == item.value }"
        @click="switchTab(item.value)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="body">
      <van-pull-refresh
        class="scroll"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="发生异常，请刷新！"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="item"
            v-for="(item, i) of list"
            :key="i"
            @click="toDetail(item.ordersn)"
          >
            <div class="head">
              <div class="date">
                <img src="@/assets/groupRob/clock.png" alt="" class="icon" />
                <span>{{ item._date }}</span>
              </div>
              <span class="status">{{ statusMap[item.status] }}</span>
            </div>
            <div class="goods">
              <div class="thumb">
                <img :src="item.sku_image" alt="" class="icon" />
                <div class="tip">{{ item.join_count }}人已参与</div>
              </div>
              <div class="info">
                <div class="title line3">
                  {{ item.goods_name }}
                </div>
                <div>
                  <div class="desc">共{{ item.quantity }}件</div>
                  <div class="price">
                    <span>工厂价</span>
                    <span class="rmb">¥</span>
                    <span class="large">{{ item._price_l }}</span>
                    <span class="small">.{{ item._price_s }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="action">
              <div
                v-if="item.status == 1"
                class="btn active"
                @click.stop="toPay(item)"
              >
                立即付款
              </div>
              <div v-else-if="item.status == 2" class="btn-group">
                <div class="btn active">
                  等待开抢
                </div>
                <div class="btn">{{ item._text }}</div>
              </div>
              <!-- <div
                v-else-if="item.status == 3"
                class="btn-group"
                @click.stop="rushBuy(item)"
              > -->
              <div
                v-else-if="item.status == 3"
                class="btn-group"
              >
                <div class="btn active">
                  <!-- 立即抢购 -->
                  自动抢购中
                </div>
                <div class="btn">{{ item._text }}</div>
              </div>
              <div
                v-else-if="item.status == 4 || item.status == 5"
                class="btn-group"
                @click.stop="rushBuy(item)"
              >
                <div class="btn active">
                  查看抢购结果
                </div>
                <div class="btn">{{ item._text }}</div>
              </div>
              <div
                v-else
                class="btn active"
                @click.stop="toGoods(item.real_goods_id)"
              >
                再次报名
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <Modal v-model="modelType" @close="onClose" />
    </div>
  </div>
</template>

<script>
import Modal from "./modal.vue";
import { getTimestamp, getCountDown, getFmtDate } from "./utils";
import dsbridge from "dsbridge";

const statusMap = {
  1: "待付款",
  2: "待抢购",
  3: "抢购中",
  4: "抢购成功",
  5: "抢购失败",
  6: "已关闭",
};

export default {
  components: {
    Modal,
  },
  created() {
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.client = "ios";
    } else if (/android/.test(ua)) {
      this.client = "android";
    }
    this.tabIndex = this.$route.params.status;
  },
  mounted() {
    window.setPay = this.setPay;
  },
  watch: {
    $route(e) {
      this.tabIndex = e.params.status;
      this.onRefresh();
    },
  },
  data() {
    return {
      statusMap: statusMap,
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      page: 0,
      list: [],
      tempList: [], // 倒计时临时数组
      modelType: null,
      client: null,
      tabIndex: 0,
      tempOrder: null,
      tabs: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "待付款",
          value: 1,
        },
        {
          label: "待抢购",
          value: 2,
        },
        {
          label: "抢购中",
          value: 3,
        },
        {
          label: "已抢到",
          value: 4,
        },
        {
          label: "未抢到",
          value: 5,
        },
      ],
      pending: false,
    };
  },
  methods: {
    switchTab(index) {
      let _path = `/grouprob/b/${index}`;
      if (this.$route.path != _path) {
        this.$router.replace(`/grouprob/b/${index}`);
      }
    },
    onRefresh() {
      this.finished = false;
      this.error = false;
      this.loading = true;
      this.page = 0;
      this.onLoad();
    },
    onLoad() {
      if (this.finished) {
        return;
      }
      if (!this.refreshing) {
        this.loading = true;
      }
      this.$api
        .post("onorder/member/order/panic-order-list", {
          status: this.tabIndex,
          page: ++this.page,
          size: 10,
        })
        .then((res) => {
          // res.list = [
          //   {
          //     id: 1,
          //     status: 2,
          //     activity_main: JSON.stringify({
          //       activity_start_at: getFmtDate(
          //         new Date(+new Date() + 10 * 1000)
          //       ),
          //       activity_end_at: getFmtDate(new Date(+new Date() + 20 * 1000)),
          //     }),
          //   },
          // ];
          if (this.page == 1) {
            this.tempList = [];
          }
          res.list.forEach((_) => {
            if (_.sale_price) {
              let _temp = _.sale_price.split(".");
              _._price_l = _temp[0];
              _._price_s = _temp[1] || "00";
            }
            _._date = getFmtDate(_.created_at, "Y-m-d H:i");
            _.activity_main = JSON.parse(_.activity_main);
            // 2待抢购
            if (_.status == 2) {
              let _second =
                getTimestamp(_.activity_main.activity_start_at) -
                getTimestamp();
              _second = Math.floor(_second / 1000);
              if (_second > 0) {
                // 大于24小时
                if (_second > 24 * 60 * 60) {
                  _._text = getFmtDate(
                    _.activity_main.activity_start_at,
                    "m月d日"
                  );
                } else {
                  _._second = _second;
                  _._text = getCountDown(_second, "h小时m分钟s秒");
                  this.tempList.push(_);
                }
              }
            }
            // 3抢购中
            if (_.status == 3) {
              let _second =
                getTimestamp(_.activity_main.activity_end_at) - getTimestamp();
              _second = Math.floor(_second / 1000);
              if (_second > 0) {
                _._second = _second;
                _._text = getCountDown(_second, "h小时m分钟s秒");
                this.tempList.push(_);
              }
            }
            if (this.tempList.length) {
              this.startCountDown();
            }
          });
          if (this.page == 1) {
            this.list = res.list;
          } else {
            this.list = this.list.concat(res.list);
          }
          console.log(this.list);
          this.finished = res.current_page >= res.last_page;
        })
        .catch((e) => (this.error = true))
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    rushBuy(order) {
      if (this.pending) {
        return;
      }
      this.pending = true;
      this.$toast.loading({
        duration: 0,
      });
      this.$api
        .post("onorder/member/order/panic-buying", { id: order.id })
        .then((res) => {
          this.tempOrder = order;
          if (res.status) {
            this.modelType = "success";
          } else {
            this.modelType = "fail";
          }
          this.$toast.clear();
        })
        .catch((err) => {
          if (err.code === 231904) {
            this.$toast("请重试");
          } else {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          }
        })
        .finally(() => (this.pending = false));
    },
    onClose() {
      if (this.tempOrder) {
        this.toDetail(this.tempOrder.ordersn);
      }
    },
    startCountDown() {
      this._timer && clearInterval(this._timer);
      this._timer = setInterval(() => {
        this.tempList = this.tempList.filter((_) => {
          _._second -= 1;
          if (_._second <= 0) {
            if (_.status == 2) {
              _.status = 3;
              let _second =
                getTimestamp(_.activity_main.activity_end_at) - getTimestamp();
              _second = Math.floor(_second / 1000);
              _._second = _second;
              _._text = getCountDown(_second, "h小时m分钟s秒");
              return true;
            } else {
              _.status = 5;
              return false;
            }
          } else {
            _._text = getCountDown(_._second, "h小时m分钟s秒");
            return true;
          }
        });
        if (!this.tempList.length) {
          clearInterval(this._timer);
        }
      }, 1000);
    },
    toDetail(id) {
      this.$router.push(`/grouprob/order/${id}`);
    },
    toPay(e) {
      let param = {
        actual_amount: e.actual_amount,
        order_amount: e.order_amount,
        ordersn: e.ordersn,
        order_type: "panic-buying",
      };
      if (this.client == "ios") {
        dsbridge.call("goPay", JSON.stringify(param), (v) => this.setPay(v));
      } else if (this.client == "android") {
        this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$toast("支付成功");
        this.onRefresh();
      }
    },
    toGoods(e) {
      this.params(e, e, "goBuy");
    },
  },
  beforeDestroy() {
    this._timer && clearInterval(this._timer);
  },
};
</script>

<style lang="less" scoped>
.body {
  flex: 1;
  overflow: auto;
}
.scroll {
  min-height: 100%;
}
.tabbar {
  height: 4.4rem;
  background: #fff;
  display: flex;
  align-items: stretch;
  white-space: nowrap;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    padding: 0 1.2rem;
    display: flex;
    align-items: center;
    position: relative;
    color: #666666;
    font-size: 1.6rem;

    &.active {
      font-size: 1.8rem;
      color: #ff1515;
      font-weight: 700;
    }

    &.active::after {
      content: " ";
      display: block;
      position: absolute;
      width: 1.8rem;
      height: 0.3rem;
      background: #ff1515;
      border-radius: 0.3rem;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.3rem;
    }
  }
}
.list {
  margin-top: 1.2rem;

  .item {
    margin: 1.2rem 1.2rem 0;
    padding: 0.8rem 0.8rem 1.2rem;
    background: #fff;
    border-radius: 0.6rem;

    &:first-of-type {
      margin-top: 0;
    }

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .date {
        display: flex;
        align-items: center;
        color: #999999;

        .icon {
          width: 1.4rem;
          height: 1.4rem;
          margin-right: 0.4rem;
        }
      }

      .status {
        color: #ff5600;
      }
    }

    .goods {
      margin-top: 1.2rem;
      display: flex;
      align-items: stretch;

      .thumb {
        flex: 0 0 11.2rem;
        height: 11.2rem;
        border-radius: 0.4rem;
        position: relative;
        overflow: hidden;
        margin-right: 0.8rem;

        .tip {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1.9rem;
          background: rgba(0, 0, 0, 0.69);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.2rem;
        }

        .icon {
          width: 100%;
          height: 100%;
        }
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 1.3rem;
          height: 3.8rem;
          line-height: 1.9rem;

          &.line3 {
            -webkit-line-clamp: 3;
            height: 5.7rem;
          }
        }

        .desc {
          font-size: 1.2rem;
          color: #999999;
        }

        .price {
          margin-top: 0.2rem;
          color: #333333;

          .rmb {
            font-size: 1.2rem;
          }

          .large {
            font-size: 1.6rem;
            font-weight: 700;
          }

          .small {
            font-size: 1rem;
          }
        }

        .other {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .desc {
            font-size: 1.3rem;

            .del {
              text-decoration: line-through;
            }
          }

          .price {
            margin-top: 0.2rem;
            font-size: 1.3rem;
            color: #ff1515;

            .rmb {
              font-size: 1.2rem;
            }

            .large {
              font-size: 2rem;
              font-weight: 700;
            }
          }

          .btn {
            flex: 0 0 7rem;
            height: 3.6rem;
            background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
            border-radius: 0.6rem;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 1.2rem;
      border-top: 0.1rem solid #f2f2f2;
      padding-top: 0.8rem;

      .btn {
        padding: 0.7rem 1.4rem;
        font-weight: 700;

        &.active {
          background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
          box-shadow: 0 0 0.3rem 0 rgba(254, 27, 68, 0.26),
            0 0 1rem 1rem rgba(255, 255, 255, 1);
          border-radius: 1.7rem;
          color: #fff;
        }
      }

      .btn-group {
        border-radius: 1.7rem;
        overflow: hidden;
        display: flex;
        background: #fae3d6;
        color: #ff570b;

        .btn.active {
          border-top-right-radius: 0;
          box-shadow: none;
        }
      }
    }
  }
}
</style>
